import { yupResolver } from '@hookform/resolvers/yup';
import {
  MANHEIM_MAIL,
  MANHEIM_MOBILE_TELEPHONE,
} from 'constants/verifyContactConstants';
import { isEmpty, values } from 'lodash';
import { useForm } from 'react-hook-form';
import { IndividualCreationSchema } from 'schemas/IndividualCreationSchema';

export const apiToFormTypes = {
  email: MANHEIM_MAIL,
  phone: MANHEIM_MOBILE_TELEPHONE,
};

export function useCreateIndividualForm({ defaultFormValues }) {
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: yupResolver(IndividualCreationSchema),
    defaultValues: defaultFormValues,
  });
  const {
    watch,
    formState: { errors, isDirty },
  } = methods;

  const notFullFilled = values(watch()).some(isEmpty);
  methods.formState.isValid = isEmpty(errors) && isDirty && !notFullFilled;
  return {
    defaultValues: defaultFormValues,
    ...methods,
  };
}
